/* eslint-disable max-len */
/* eslint-disable no-template-curly-in-string */
import * as yup from 'yup';
// import printValue from 'yup/lib/util/printValue';

async function validateExtension(file, extensions) {
  if (file) {
    const regex = new RegExp(`.(${extensions.join('|')})$`, 'i');
    return regex.test(file.name);
  }
  return true;
}

async function validateFormatColor(file) {
  if (file) {
    // const regex = new RegExp('^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)', 'i')
    return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(file)
  }

  return true
}

async function validateMimes(file, mimes) {
  const regex = new RegExp(`${mimes.join('|').replace('*', '.+')}$`, 'i');
  if (file) {
    return regex.test(file.type);
  }
  return true;
}

async function validateImage(file, width, height) {
  if (file) {
    return new Promise((resolve) => {
      const image = new Image();
      image.onerror = () => resolve(false);
      image.onload = () => resolve(image.width === width && image.height === height);
      image.src = URL.createObjectURL(file);
    });
  }
  return true;
}

export const fileExtension = extensions => ({
  name: 'ValidationError',
  test: file => validateExtension(file, extensions),
  message: 'Formato requerido: ${extensions}',
  params: { extensions },
  exclusive: false,
});

export const fileMimes = mimes => ({
  name: 'ValidationError',
  test: file => validateMimes(file, mimes),
  message: 'Formato requerido: ${extensions}',
  params: { mimes },
  exclusive: false,
});

export const imageDimensions = (width, height) => ({
  name: 'ValidationError',
  test: file => validateImage(file, width, height),
  message: 'Tamaño requerido: ${width} x ${height}.',
  params: { width, height },
  exclusive: false,
});

export const formatColor = () => ({
  name: 'ValidationError',
  test: file => validateFormatColor(file),
  message: 'Color debe ser hexadecimal',
  params: { },
  exclusive: false,
});

export const formatSelect = (keysMap, obj) => {
  const data = [];
  obj.map(e => (
    data.push(Object.keys(e).reduce(
      (acc, key) => ({
        ...acc,
        ...{ [keysMap[key] || key]: e[key] },
      }),
      {},
    ),
    )
  ));
  return data;
};

export const setLocale = () => yup.setLocale({
  mixed: {
    // default: '${path} is invalid',
    // required: '${path} is a required field',
    required: 'Es requerido',

    oneOf: '${path} must be one of the following values: ${values}',
    notOneOf: '${path} must not be one of the following values: ${values}',
    notType: ({
      path, type, value, originalValue,
    }) => {
      const number = (type === 'number') ? 'númerico' : type;
      let msg = `
      El valor debe ser de tipo \`${number}\``;

      // const isCast = originalValue != null && originalValue !== value;
      // let msg = `
      //   ${path} must be a \`${type}\` type, but the final value was: \`${printValue(value, true)}\`
      //   ${ (isCast ? ` (cast from the value \`${printValue(originalValue, true)}\`).` : '.')}
      //   `;
      if (value === null) {
        msg += '\n If "null" is intended as an empty value be sure to mark the schema as `.nullable()`';
      }
      return msg;
    },
  },
  string: {
    // length: '${path} must be exactly ${length} characters',
    // min: '${path} must be at least ${min} characters',
    // max: '${path} must be at most ${max} characters',
    // matches: '${path} must match the following: "${regex}"',
    // email: '${path} must be a valid email',
    url: 'URL inválida',
    // trim: '${path} must be a trimmed string',
    // lowercase: '${path} must be a lowercase string',
    // uppercase: '${path} must be a upper case string',
  },
  number: {
    // min: '${path} must be greater than or equal to ${min}',
    // max: '${path} must be less than or equal to ${max}',
    // lessThan: '${path} must be less than ${less}',
    // moreThan: '${path} must be greater than ${more}',
    // notEqual: '${path} must be not equal to ${notEqual}',
    // positive: '${path} must be a positive number',
    // negative: '${path} must be a negative number',
    // integer: '${path} must be an integer',
  },
  date: {
    // min: '${path} field must be later than ${min}',
    // max: '${path} field must be at earlier than ${max}',
    min: 'Debe ser mayor a ${min}',
    max: 'Debe ser menor a ${max}',
  },
  object: {
    // noUnknown: '${path} field cannot have keys not specified in the object shape',
  },
  array: {
    // min: '${path} field must have at least ${min} items',
    // max: '${path} field must have less than or equal to ${max} items',
  },
});
